import cn from 'classnames';
import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  name: string;
  fieldCount: number;
  expanded: boolean;
  onToggle: () => void;
  children?: any;
};

function HeadingSection({ name, fieldCount, expanded, onToggle, children }: Props) {
  const onKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onToggle();
    }
  };

  return (
    <div className="editor__attributes__heading" data-cy="attributes-heading">
      <div
        className="editor__attributes__heading-header"
        role="button"
        tabIndex={0}
        aria-expanded={expanded}
        onClick={onToggle}
        onKeyDown={onKeyDown}
      >
        <span className="editor__attributes__heading-control" data-cy="heading-control">
          <FontAwesomeIcon icon={expanded ? 'chevron-up' : 'chevron-down'} />
        </span>
        <h4 className="editor__attributes__heading-title">
          {name}
          <span className="editor__attributes__heading-count">{`${fieldCount} fields`}</span>
        </h4>
      </div>

      <div
        className={cn('editor__attributes__heading-content', {
          'editor__attributes__heading-content--collapsed': !expanded
        })}
      >
        {children}
      </div>
    </div>
  );
}

export default HeadingSection;
